// extracted by mini-css-extract-plugin
export default {"pageHeader":"Drafts_pageHeader__iYO4G","pageTitle":"Drafts_pageTitle__nd9VO","filters":"Drafts_filters__dltAx","statusFilter":"Drafts_statusFilter__qvcoR"};